import Unsubscribe from './Unsubscribe';

const index = {
  Unsubscribe,
};

export default index;
